import React from 'react';
import { View } from 'react-native';
import { styles } from './styles';

export const GridTemplate = ({ children, style = {}, ...props }) => (
  <View style={[styles.grid, style]} {...props}>{children}</View>
);
